"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This function iterates over a list of provided bids, logging each bid to ATHA when
 * sendEvents flag is active and finally returns what we determine is the
 * best bid for us from the entire list.
 *
 * @param {array} bids A list containing valid and malformed bids
 * @param {string} adUnitId the placement ID of the element in the DOM that is populated with the best bid
 * @param {boolean} sendEvents A flag indicating whether all of the provided bids are logged to ATHA or not.
 * @returns {object} bestBid
 */
function getBestBid(bids, adUnitId, sendEvents) {
    var bestBid = {};
    // When we receive zero bids back from the auction result, return a blank bid object.
    if (!Array.isArray(bids) || bids.length === 0) {
        return bestBid;
    }
    bids.forEach(function (currentBid) {
        var _a;
        // IMPORTANT: We overwrite bid id with atha id here for potentially tracking. When adding back, possibly extract atha stuff one later up to module.
        if (typeof window.__atha !== "undefined" && sendEvents) {
            var id = window.__atha.sendBid(adUnitId !== null && adUnitId !== void 0 ? adUnitId : "unknown", (_a = currentBid === null || currentBid === void 0 ? void 0 : currentBid.partner) !== null && _a !== void 0 ? _a : "unknown", currentBid === null || currentBid === void 0 ? void 0 : currentBid.bic, // bic = bid price in cents (CPM*100)
            currentBid === null || currentBid === void 0 ? void 0 : currentBid.dimensions);
            currentBid.id = currentBid.source_bid.id = id;
        }
        if ((!bestBid.bic || currentBid.bic > bestBid.bic) &&
            !isNaN(currentBid.bic)) {
            // bic = bid price in cents (CPM*100)
            bestBid = currentBid;
        }
    });
    return bestBid;
}
exports.default = getBestBid;
